// Pure, DOM-free helpers shared by wishlist.js + wishlist-manage.js. Dual-export:
// browser → window.WishlistHelpers; node:test → module.exports.
(function (root) {
  function toProductGid(idOrGid) {
    var s = String(idOrGid);
    return s.indexOf("gid://") === 0 ? s : "gid://shopify/Product/" + s;
  }
  function uniqueGids(gids) {
    var seen = {}, out = [];
    for (var i = 0; i < gids.length; i++) {
      var g = gids[i];
      if (g && !seen[g]) { seen[g] = true; out.push(g); }
    }
    return out;
  }
  function savedListIds(checkMap, gid) {
    return (checkMap && checkMap[gid]) || [];
  }
  function isSaved(checkMap, gid) {
    return savedListIds(checkMap, gid).length > 0;
  }
  function formatMoney(money) {
    if (!money) return "";
    var n = Number(money.amount);
    return "$" + (isNaN(n) ? money.amount : n.toFixed(2)) + " " + money.currencyCode;
  }
  function isIssueSentinel(gid) {
    return typeof gid === "string" && gid.indexOf("gid://captcan/Issue/") === 0;
  }
  function sortItems(items, mode) {
    var arr = items.slice();
    if (mode === "price") {
      arr.sort(function (a, b) {
        var pa = a.price == null ? Infinity : a.price, pb = b.price == null ? Infinity : b.price;
        return pa - pb;
      });
    } else if (mode === "title") {
      arr.sort(function (a, b) { return String(a.title).toLowerCase().localeCompare(String(b.title).toLowerCase()); });
    } else {
      arr.sort(function (a, b) { return a.pos - b.pos; }); // "date" = original order
    }
    return arr.map(function (it, i) { return { pos: it.pos, order: i }; });
  }
  // Client-side window over the full rendered row set. pageSize 0 = "All" (one page).
  // Mirrors sliceRange/normalizePageParam in apps/web/app/lib/holdbox-pagination.ts, which
  // is server-only TypeScript this theme asset cannot import.
  function pageWindow(total, pageSize, page) {
    var size = pageSize > 0 ? pageSize : total;
    var totalPages = size > 0 ? Math.ceil(total / size) : 1;
    if (totalPages < 1) totalPages = 1;
    var current = Math.min(Math.max(parseInt(page, 10) || 1, 1), totalPages);
    if (!total) return { page: 1, totalPages: totalPages, start: 0, end: 0 };
    return {
      page: current,
      totalPages: totalPages,
      start: (current - 1) * size + 1,
      end: Math.min(current * size, total),
    };
  }
  var api = { toProductGid: toProductGid, uniqueGids: uniqueGids, savedListIds: savedListIds, isSaved: isSaved, formatMoney: formatMoney, isIssueSentinel: isIssueSentinel, sortItems: sortItems, pageWindow: pageWindow };
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  else root.WishlistHelpers = api;
})(typeof globalThis !== "undefined" ? globalThis : this);
